import React from 'react';

export const LandingFocusShowcase: React.FC = () => {
  return (
    <section
      id="focus"
      className="max-w-[1248px] mx-auto px-5 md:px-6 py-10 md:py-16 flex flex-col md:flex-row items-center gap-6 md:gap-12"
    >
      {/* Left Column: Description & Bullet Checklist */}
      <div className="flex-1 w-full flex flex-col gap-3.5 md:gap-4">
        <h2 className="text-[26px] md:text-4xl font-extrabold leading-[1.3] m-0 text-base-content">
          فقط شما، ساز و مترونوم
        </h2>
        <p className="text-[15px] md:text-base leading-[1.9] md:leading-[1.9] text-base-content/60 m-0">
          <span className="hidden sm:inline">
            در حالت تمرکز همه‌چیز جز زمان بلوک، تمپو و ضرب محو می‌شود. با فاصله از گوشی هم خوانا است.
          </span>
          <span className="sm:hidden">
            در حالت تمرکز همه‌چیز جز زمان بلوک، تمپو و ضرب محو می‌شود.
          </span>
        </p>

        <ul className="hidden sm:flex flex-col gap-2.5 p-0 m-0 list-none text-sm md:text-[15px] text-base-content/80">
          <li className="flex items-center gap-2.5">
            <svg
              className="size-4.5 text-success-soft shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <span>صفحه در طول جلسه خاموش نمی‌شود</span>
          </li>
          <li className="flex items-center gap-2.5">
            <svg
              className="size-4.5 text-success-soft shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <span>ثبت تمپوی تمیز در پایان هر بلوک</span>
          </li>
          <li className="flex items-center gap-2.5">
            <svg
              className="size-4.5 text-success-soft shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
            <span>نمودار پیشرفت هفتگی در داشبورد</span>
          </li>
        </ul>
      </div>

      {/* Right Column: Dark HUD Mockup Card */}
      <div
        data-testid="landing-focus-showcase"
        aria-hidden="true"
        className="w-full md:w-auto md:flex-[1_1_420px] bg-hud border border-base-300 rounded-[22px] md:rounded-3xl shadow-hud p-6 sm:p-10 flex flex-col items-center gap-3 md:gap-3.5 text-center select-none"
      >
        <span className="h-6 md:h-6.5 px-2.5 md:px-3 rounded-full bg-primary/14 text-primary-soft text-[11px] md:text-xs font-semibold inline-flex items-center">
          <span className="hidden sm:inline">بلوک ۲ از ۴ · رپرتوار</span>
          <span className="sm:hidden">بلوک ۲ از ۴</span>
        </span>

        <p
          dir="ltr"
          className="m-0 font-mono text-[72px] md:text-[96px] font-semibold leading-none text-base-content"
        >
          05:48
        </p>

        <div dir="ltr" className="flex items-center gap-2.5 md:gap-3">
          <span className="size-3 md:size-3.5 rounded-full bg-secondary shadow-[0_0_14px_rgba(16,185,129,0.7)]" />
          <span className="size-2.5 md:size-3 rounded-full bg-base-300" />
          <span className="size-2.5 md:size-3 rounded-full bg-base-300" />
          <span className="size-2.5 md:size-3 rounded-full bg-base-300" />
        </div>

        <p dir="ltr" className="hidden sm:block m-0 font-mono text-sm text-base-content/60">
          128 BPM → 140
        </p>
      </div>
    </section>
  );
};
